import { createI18n } from "vue-i18n";

import cs from "../locales/cs.json";

const lang = import.meta.env?.VITE_VUE_APP_LOCALE ?? "cs";

export const i18n = createI18n({
    legacy: false,
    locale: lang,
    fallbackLocale: "cs",
    messages: { cs },
    datetimeFormats: {
        cs: {
            long: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                weekday: "long",
                hour: "numeric",
                minute: "numeric",
            },
        },
    },
});
